export default {
  en: {
    general: {
      customer: "Customer",
      product_group: "Product group",
      id: "ID",
      name: "Name",
      actions: "Actions",
      reports: "Reports",
      report: "Report",
      products: "Products",
      unit: "Unit",
      format: "Type",
      category: "Category",
      shortcut: "Shortcut",
      waiting: "Waiting",
      in_progress: "In Progress",
      text: "Text",
      delete: "Delete",
      move: "Move",
      completed: "Published",
      confirm: "Confirm",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      save_order: "Save Order",
      edit: "Edit",
      remove: "Remove",
      clear: "Clear",
      select: "Select",
      search: "Search",
      overwrite: "Overwrite",
      created: "Created",
      date: "Date",
      please_wait_data_from_cedoon: "Please wait while data is retrieved from CEDOON.",
      loading_data: "Loading data...",
      deleting: "Deleting...",
      copied_to_clipboard: "Copied to Clipboard",
      supervisor_name: "Name of QC Manager",
      measurements: "Measurements",
      sheets: "Sheets",
      min: "min",
      max: "max",
      test_template: "Test Template",
      value_required: "Value required",
      or: "or",
      boolean: "boolean",
      optional: "optional",
      order: "Order",
      print: "Print",
      email: "E-Mail",
      password: "Password",
      base_data: "Base Data",
      search_criteria: "Search Criteria",
      from: "from",
      to: "to",
      data: "Data",
      select_or_drop_file_here: "Select File",
      error: {
        error: "Error",
        title: "An error occurred",
        generic_error: "Please try again later.",
        loading_data: "Error Loading Data",
        id_doesnt_exist: "Given ID does not exist or error occured",
        oops: "Oops, that should not have happened!",
        communication_error:
          "A communication error occured. Please check your network connection and contact your administrator."
      },
      success: "Success!",
      administration: "Administration",
      files: "Upload Files",
      drop_file_here: "Drop files here or click to select Files",
      description: "Description",
      submit_report: "Submit Report",
      complete_report: "Publish Report",
      critical: "Critical",
      max_diff: "Max. Δ"
    },
    portal: {
      page_header: "Page Header",
      logout: "Logout",
      dashboard: "Dashboard",
      create_report: "Create Report",
      manage_reports: "Manage Reports",
      search_reports: "Search Reports",
      view_report: "View Report",
      change_language: "Language"
    },
    login: {
      credentials_dont_match: "These credentials do not match any of our records.",
      login: "Login",
      enter_email: "Enter your email address",
      enter_password: "Enter your password"
    },
    reports_index: {
      create_new: "Create new report",
      no_reports_waiting: "No reports 'WAITING'",
      no_reports_in_progress: "No reports 'IN PROGRESS'",
      no_reports_completed: "No reports 'PUBLISHED'",
      measurements_done: "Measurements done",
      no_reports_finished_measurement: "No reports 'MEASUREMENTS DONE'",
      no_reports_found: "No reports found",
      dialog: {
        delete_message: "Would you really like to delete <strong>{report_number} - {report_name}</strong>?"
      }
    },
    reports_search_list: {
      test_report_list: "Test Report List"
    },
    report: {
      report_information: "Report Information",
      report_no: "Report No.",
      description: "Report Description",
      customer_name: "Customer Name",
      customer_order_no: "Customer Order No.",
      supplier_name: "Supplier Name",
      supplier: "Supplier",
      plant: "Plant",
      shipping_date: "Shipping Date",
      order_date: "Order Date",
      checked_with: "Checked With",
      product_information: "Product Information",
      article_no: "Article No.",
      charge: "Charge",
      surface: "Surface",
      head: "Head",
      head_stamp: "Head Stamp",
      recess: "Recess",
      recess_size: "Recess Size",
      thread_type: "Thread Type",
      point: "Point",
      drawing_no: "Drawing No.",
      batch: "Batch",
      material_certificate: "Material Certificate",
      heat_nr: "Heat No.",
      order_quantity: "Batch Quantity",
      sheet_amount: "(no sheets) | (1 sheet) | ({amount} sheets)",
      wood_information: {
        wood_information: "Wood Information",
        wood_no: "Wood No.",
        insertion_direction: "Insertin Direction",
        wood_moisture: "Wood Moisture",
        wood_density: "Wood Density",
        room_temperature: "Room Temperature",
        room_moisture: "Room Moisture"
      },
      progress: "Progress",
      customer: "Customer",
      data_validation: "Test Result",
      attachments_for: "Attachments for",
      loading_report: "Loading Report ...",
      loading_reports: "Loading Reports ...",
      error_loading_report: "Error Loading Report",
      template: "Template",
      sales_contract: "Sales Contract No.",
      screw_type: "Screw Type",
      screw_diameter: "Screw Diameter",
      screw_length: "Screw Length",
      no_samples: "No. Samples",
      customer_drawing_number: "Customer-Drawing Number",
      work_order_nr: "Work Order No.",
      attachments: "Attachments",
      no_attachments: "This report doesn't have any attachments.",
      no_attachments_sheet: "This sheet doesn't have any attachments.",
      upload: {
        title: "Upload File",
        wrong_file_type: "Wrong Filetype (only PNG/JPG/PDF)",
        upload_file: "Upload File"
      },
      success: {
        measurements: {
          message: "Measurements successfully saved"
        },
        info: {
          message: "Report information successfully saved"
        },
        wood_info: {
          message: "Wood information successfully saved"
        },
        sheet_info: {
          message: "Sheet information successfully saved"
        }
      }
    },
    reports_show: {
      dialog: {
        message: "Would you like to delete this attachment"
      },
      no_report_found: "No report found",
      no_report_found_url: "No report can be found with this URL"
    },
    reports_create: {
      heading: "Create Report",
      configure_heading: "Configure Report",
      report_data: "Report Data",
      report_data_description: "Please enter basic data for the report",
      checking_report_number: "Checking report number",
      number_in_use: "This number is currently in use",
      use_instead: "Use {number} instead",
      number_available: "The number is available",
      add_product: "Add Product",
      select_products: "Please select procuts you want to check with this report",
      bulk_import_measurements: "Bulk Import of Measurements",
      select_test_template: "Select a test template",
      import_measurements: "Import of Measurements for Single Product",
      some_characteristics_wont_be_imported:
        "Some characteristic are not present on the test template and will not be imported. (marked orange)",
      overwrite_dialog: {
        message:
          "This report sheet already contains measurements.<br/> Would you like to <strong>overwrite</strong> existing data?"
      },
      bulk_overwrite_dialog: {
        message:
          "The following products already contain data.<br/> {overwrittenText} Would you like to <strong>overwrite</strong> the data of all products?"
      },
      delete_dialog: {
        message: "This sheet may already contain data.<br/> Would you like to <strong>delete</strong> it?",
        success: "Successfully removed sheet from report.",
        error: "An error occurred while removing the sheet. Please try again later."
      }
    },
    reports_search: {
      heading: "Search Reports"
    },
    reports_view: {
      heading: "View Reports",
      enter_charge_and_article_no: "Please enter batch number and article number!",
      select_at_least_one_characteristic: "Select at least one characteristic."
    },
    reports_print: {},
    products: {
      description: "Product Description",
      import: "Import Products",
      add_new: "Add New Product",
      loading_products: "Loading products...",
      no_products_available: "No products available",
      no_products_found: "No products found",
      start_by_adding_new_products: "Start by adding new products",
      error_deleting: "An error occurred while deleting the product",
      success_deleting: "Successfully deleted product",
      deletion_text: "Would you really like to delete <strong>{description}</strong>?",
      use_proposed_value: 'Use proposed description "{description}"'
    },
    products_edit: {
      heading: "Edit Product",
      master_data: "Master Data",
      assign_test_template: "Assign test templates",
      add_test_template: "Add Test Template",
      range_value: "Range / Value",
      no_test_templates: "No test templates available",
      test_template_remove_try_dialog: {
        message: "This test template is used in a report and cannot be removed from the product!"
      },
      remove_template_dialog: {
        message:
          "Would you like to remove <strong>' + {templateName} + '</strong> from this product?<br/>This action is executed immediately and cannot be undone."
      }
    },
    products_create: {
      heading: "Create a Product",
      enter_properties: "Enter Product Properties"
    },
    products_import: {
      heading: "Import Products & Tolerances",
      step_1: "Step 1 - Import Products",
      import_data: "Import data",
      importing_data: "Importing data...",
      import_successful: "Import successful!",
      need_help: "Need help?",
      need_help_text_columns_allowed:
        "The following columns are allowed {column} (which means, that these columns can appear multiple times)",
      need_help_text_columns_required: "The following columns have to be provided",
      step_2: "Step 2 - Import Tolerances",
      article_number_of_product: "Article number of product",
      which_template: " the template that is going to be used",
      shorthand_of_characteristic: "Shortcut of characteristic",
      target_value: "Target Value",
      ok_nok_field: "ok/nok Field",
      sequence_of_characteristics: "Sequence in which characteristics appear",
      characteristic_key: "characteristic_key",
      validate: "Validate data",
      is_validating: "Validating...",
      errors_occurred: "Found errors, please check the table below and re-upload the file after fixing all the errors",
      clear: "Clear",
      errors: {
        MISSING_REQUIRED_PROPERTY: "Missing required property",
        UNALLOWED_MULTIPLE_VALUES: "Found multiple values on a single-value property",
        UNKNOWN_VALUE: "Found an unknown value on a selection property",
        COMPANY_DOES_NOT_EXIST: "Company does not exist",
        PRODUCT_EXISTS: "Product with given article number and customer exists already",
        TEMPLATE_DOES_NOT_EXIST: "Test template does not exist",
        PRODUCT_DOES_NOT_EXIST: "Product does not exist",
        CHARACTERISTIC_NOT_ASSIGNED: "Characteristic is not assigned to test template",
        UNKNOWN_CHARACTERISTIC: "Unknown characteristics id found"
      }
    },
    products_search: {
      choose_products: "Choose Products",
      add_selected_products: "Add Selected Products",
      multiple_customers_error: "You can only add products from the same customer"
    },
    calculation: {
      rtor_k1: "Charac. Tors. Resis. (Rtor,k_5%)",
      rtor_k2: "Charac. Tors. Resis. (Rtor,k_95%)",
      rtor_mw: "Avg. Tors. Resis. (Rtor,avg)",
      ftor_k1: "Charac. Breaking Torque (Ftor,k)",
      fax_k1: "Charac. Withdrawal Param. (Fax,k)",
      my_k1: "Charac. Yield Moment (My,k)",
      fhead_k1: "Charac. Head Pull-thr. Param. (Fhead,k)",
      ftens_k1: "Charac. Tensile Capacity (Ftens,k)",
      tor_rat_1: "Torsional Ratio (TR,k_5%)",
      tor_rat_2: "Torsional Ratio (TR,k_95%)",
      tor_rat_3: "Torsional Ratio (TR,avg)",
      ftor_k1_raw: "Charac. Breaking Torque (ftor,raw)",
      rtor_k1_raw: "Charac. Tors. Resis. (Rtor,k5_raw)",
      rtor_k2_raw: "Charac. Tors. Resis. (Rtor,k95_raw)",
      rtor_mw_raw: "Avg. Tors. Resis. (Rtor,avg_raw)"
    },
    characteristics: {
      product_characteristics: "Product Characteristics",
      characteristic: "Characteristic",
      characteristics: "Characteristics",
      assign_characteristics: "Assign Characteristics",
      assigned_characteristics: "Assigned Characteristics",
      loading_characteristics: "Loading characteristics...",
      already_in_use: "This characeristic is already in use and cannot be deleted!",
      available_characteristics: "Available Characteristics",
      critical_characteristic: "Critical Characteristic"
    },
    characteristics_index: {
      add_new: "Add New Characteristics",
      no_characteristics_available: "No characteristics available",
      start_by_adding_new_characteristics: "Start by adding new characteristics",
      dialog: {
        message: "Would you like to delete <strong>{localizedKey}</strong>?"
      }
    },
    characteristics_create: {
      heading: "Create New Product Characteristics",
      error_while_creating: "Error occured while creating new characteristics"
    },
    templates_index: {
      create_new: "Create New Test Template",
      loading_templates: "Loading test templates...",
      no_templates_available: "No test templates available",
      start_by_adding_a_new_template: "Start by adding a new test template"
    },
    templates_create: {
      create_new: "Create New Test Template",
      selected_characteristics: "Selected Characteristics",
      available_characteristics: "Available Characteristics"
    },
    template_view: {
      title: "Test template: {name}",
      info_text: "You can change the order of characteristics by 'Drag & Drop'.",
      assigned_characteristics: "Assigned characteristics",
      loading: {
        title: "Loading characteristics...",
        subtitle: "Please wait while CEDOON is loading characteristics.",
        error: {
          title: "An error occurred while loading.",
          subtitle: "ID does not exist or an other error occurred"
        }
      },
      saving: {
        success: "New order successfully saved.",
        button: "Save order"
      }
    },
    characteristic_titles: {
      report_number: "Report No.",
      screw: "Screw",
      test_acc: "Test acc.",
      valid_from: "Valid from",
      supplier_name: "Supplier Name",
      sales_contract: "Sales Contract",
      shipping_date: "Shipping Date",
      size: "Size",
      work_order: "Work Order",
      customer_name: "Customer Name",
      head: "Head",
      thread: "Thread",
      point: "Point",
      recess: "Recess",
      customer_order_name: "Customer Order No.",
      surface: "Surface",
      drawing_no: "Drawing No.",
      head_mark: "Head Mark",
      article_number: "Article No.",
      batch: "Batch No.",
      material_certificate: "Material Certificate No.",
      heat_no: "Heat No.",
      insp_items: "Inspected Items",
      shippment_date: "Shipping Date",
      wood_nr: "Wood No.",
      insertion_direction: "Insertion Direction",
      wood_moisture: "Wood Moisture",
      wood_density: "Wood Density",
      room_temperature: "Room Temperature",
      room_moisture: "Room Moisture"
    },
    data_types: {
      TEXT: "Text per Sample",
      FLOAT: "Numeric per Sample",
      BOOLEAN: "2-Choices (OK/NOK) per Sample",
      ONE_BOOLEAN_PER_CHARACTERISTIC: "2-Choices (OK/NOK) per characteristics",
      ONE_FLOAT_PER_CHARACTERISTIC: "Numeric per characteristics",
      ONE_BOOLEAN_PER_PRODUCT: "2-Choices (OK/NOK) per Product",
      ONE_TEXT_PER_PRODUCT: "Text per Product"
    },
    file_upload: {
      title: "Upload File",
      category_file: "Select category and choose file.",
      category: "Category",
      file_name: "File Name",
      mc: "Material Certificate",
      company: "Company",
      dropzone: {
        text: "Drop files here or click to select files.",
        allowed_file_types: "Allowed file types: {types}",
        wrong_file_type: "File type is not allowed.",
        please_select: "Drop files here or click to select files."
      },
      saving: {
        button: "Upload",
        error: "Error while uploading file. Please try again.",
        success: "File successfully uploaded.",
        file_exists: "A file with this name already exists."
      }
    },
    print_report_dialog: {
      title: "Print to PDF",
      subtitle: "Settings",
      layout: "Layout",
      language: "Language",
      generate: "Generate PDF",
      save: "Save PDF",
      open: "Open PDF",
      send: "Send PDF",
      recipient: "Recipient E-Mail",
      recipient_text: "Please enter the recipient's email address",
      recipient_valid_email: "Please enter a valid email address!",
      attachments: {
        title: "Include Attachments",
        pdf: "PDF Attachments",
        image: "Image Attachments",
        characteristic: "Characteristic Attachments",
        material_certificate: "Material Certificate",
        technical_drawing: "Technical Drawing"
      }
    },
    layouts: {
      STANDARD: "Standard",
      DECKMATE: "Deckmate",
      DEMO: "Demo"
    },
    submit_report: {
      error: "Please enter your name!",
      text: "Please enter your name to submit this report. You cannot edit the report afterwards!",
      success: "Report successfully submitted"
    },
    files: {
      loading: {
        title: "Loading files...",
        subtitle: "Please wait while files are retrieved from CEDOON.",
        error: {
          title: "Error loading files.",
          subtitle: "Please try again later."
        }
      },
      title: "Upload Files",
      header: {
        file_name: "File Name",
        category: "Category",
        uploaded_by: "Uploaded by"
      }
    },
    report_step: {
      CREATED: "Waiting",
      IN_PROGRESS: "in Progress",
      DONE_GATHERING: "Measurements Done",
      COMPLETED: "Published"
    },

    report_filter: {
      heading: "Filter Reports",
      timeframe: "Timeframe",
      one_week: "1 Week",
      one_month: "1 Month",
      one_year: "1 Year",
      progress: "Progress",
      customer: "Customer",
      data_validation: "Test Result",
      number_of_reports_by_status: "Number of Reports by Status",
      please_click_tiles_to_choose: "Please Click Tiles To Choose",
      quickfilter: "Quickfilter",
      screw_length: "Screw Length",
      screw_diameter: "Screw Diameter"
    },
    complete_report: {
      error: "Please enter your name!",
      text: "Please enter your name to publish this report",
      success: "Report successfully published"
    }
  }
};
